import ServiceEndpoints from "../ServiceEndpoints";
import {FilesUploaded, FileUploadsForm} from "../../model/FilesUploaded";

const baseUrl = ServiceEndpoints.FetchFilesUploaded;

const fetchFilesUploaded = async (form: FileUploadsForm, token: any): Promise<FilesUploaded[]> => {
    const response = await fetch(`${baseUrl}`, {
        method: 'POST',
        headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
        body: JSON.stringify(form)
    });

    if (!response.ok) {
        throw new Error('Network response error');
    }

    return response.json();
};

export { fetchFilesUploaded };